import { NavigationService } from '../core/services/navigation.service';
import { ErrorService } from '../core/services/error.service';
import { UtilModule } from '../core/shared/util/util.module';
import { AuthenticationService } from '../core/services/authentication.service';
import { BrowserModule, HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, ErrorHandler, Injectable, LOCALE_ID } from '@angular/core';
import { BootRoutingModule } from './boot-routing.module';
import { BootComponent } from './boot.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { RootStoreModule } from '../core/store/root-store.module';
import { ApiModule } from '../core/modules/api.module';
import { CanSignInRoute, IsAuthLoaded, CheckVersionGuard } from '../core/guards/auth.guards';
import { SportsService } from '../features/sports/services/sports.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ClipboardModule } from 'ngx-clipboard';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as myGlobals from './globals'; // <==== Augmentations
import { GlobalErrorHandler } from '../core/services/global-error-handler.service';
import { MatDialogRef, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { LogoModule } from '../features/layout/components/logo/logo.module';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { SYSTEM_VERSION } from 'src/version';
import { CleanSubscriptions } from '../core/classes/clean-subcriptions';
import { DefaultForm } from '../core/classes/default-form';
import { MaterialModule } from '../core/shared/util/material/material.module';
import { FormModule } from '../core/shared/form/form.module';
import { NgxMaskModule } from 'ngx-mask';
import * as Hammer from 'hammerjs';
import { CookieMessageModule } from '../features/system/components/cookie-message/cookie-message.module';
import localePt from '@angular/common/locales/pt';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { ScreenTrackingService, UserTrackingService, DEBUG_MODE, APP_NAME, APP_VERSION } from '@angular/fire/compat/analytics';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { StorageService } from '../core/services/storage.service';
import { ImageService } from '../features/images/services/image.service';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IntlService } from '../core/services/intl.service';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';

registerLocaleData(localePt, 'pt');

@Injectable({ providedIn: 'root' })
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}


// call to prevent tree shaking
const GLB = myGlobals.GLOBALS;
const hasServiceWorker = ['staging', 'production'].includes(environment.environment);

export const MY_FORMATS = {
  parse: {
    dateInput: ['l', 'LL'],
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    BootComponent,
    DefaultForm,
    CleanSubscriptions,
  ],
  imports: [
    BrowserModule,
    BootRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    provideFirebaseApp(() => initializeApp(environment.firebase.config)),
    provideFirestore(() => getFirestore()),
    provideAnalytics(() => getAnalytics()),
    provideStorage(() => getStorage()),
    provideAuth(() => getAuth()),

    RootStoreModule,
    ClipboardModule,
    ApiModule.forRoot(),
    UtilModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js',
      { enabled: hasServiceWorker, registrationStrategy: 'registerImmediately' }
    ),
    MatProgressBarModule,
    LogoModule,
    MaterialModule,
    FormModule,
    NgxMaskModule.forRoot(),
    HammerModule,
    CookieMessageModule,
    MonacoEditorModule.forRoot()
  ],
  providers: [
    StorageService,
    ImageService,
    AuthenticationService,
    ErrorService,
    CanSignInRoute,
    IsAuthLoaded,
    CheckVersionGuard,
    SportsService,
    NavigationService,
    ScreenTrackingService,
    UserTrackingService,
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MatDialogRef, useValue: {} },

    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_CHIPS_DEFAULT_OPTIONS, useValue: { separatorKeyCodes: [ENTER, COMMA] } },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    {
      provide: LOCALE_ID,
      deps: [IntlService],
      useFactory: (intl: IntlService) => intl.getLocaleId()  // returns locale string
    },

    // Firebase Analytics Options
    { provide: DEBUG_MODE, useValue: false }, // !environment.production
    { provide: APP_NAME, useValue: 'Gioco' },
    { provide: APP_VERSION, useValue: SYSTEM_VERSION.version },
  ],
  bootstrap: [BootComponent]
})
export class BootModule { }
